import { MARQUEE } from "@/data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-display italic font-light text-6xl md:text-8xl lg:text-[9rem] px-8 md:px-12 text-transparent [-webkit-text-stroke:1px_rgba(197,160,89,0.55)] hover:text-[#C5A059] transition-colors duration-700">
          {w}
        </span>
        <span className="h-3 w-3 rotate-45 bg-[#C5A059]/70" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative py-14 md:py-20 border-y border-white/5 overflow-hidden bg-[#0A0A0C]" data-testid="destinations-marquee" aria-label="Destinos">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </section>
);
